$(document).ready(function(evt){
	resizeIFrame();
});

$(window).resize( function() {
	resizeIFrame();
});

function resizeIFrame() {
	if ($('iframe').length > 0) {

	    $('iframe').each(function() {
	        var width = $(this).outerWidth();
	        var height = width * 0.57;
	        $(this).css('height', height + 'px');
	    });
	}
}